import PropTypes from 'prop-types'
import { Textarea } from '../index.js'
import Validation from '../../wizard/Validation.jsx'

const TextareaWiz = (props) => {
    const dataFieldText =
        props.keyName.substring(props.keyName.lastIndexOf('.') + 1) ||
        props.keyName
    const labelFieldText = props.keyName
        .split('.')
        .map((t) => parseInt(t) || t)
        .filter((i) => isNaN(i))
        .join('.')
    const validationFieldText = props.keyName
        .split('.')
        .map((t, i) =>
            i === 0 && props.idx !== undefined ? `${t}.${props.idx}` : t
        )
        .join('.')
    const form = props.name ? props.wiz.form?.[props.name] : props.wiz.form
    const value = props.value
        ? props.value
        : props.row
        ? props.row?.[dataFieldText]
        : form?.[dataFieldText]
    const setter = props.setRow ? props.setRow : props.wiz.setValue

    return (
        <Validation wiz={props.wiz} field={props.keyName}>
            <Textarea
                label={props.label || props.wiz.getLabel(labelFieldText)}
                tooltipText={props.wiz.getToolTip(
                    props.keyName || labelFieldText || dataFieldText
                )}
                name={props.name || dataFieldText}
                value={value || ''}
                disabled={props.disabled}
                readOnly={props.readOnly}
                placeholder={props.placeholder}
                onlyNumbers={props.onlyNumbers}
                limitterFloat={props.limitterFloat}
                rows={props.rows}
                className={props.className}
                hideLimitter={props.hideLimitter}
                noLabel={props.noLabel}
                limit={props.wiz.getMax(labelFieldText)}
                title={props.title || props.wiz.getLabel(labelFieldText)}
                id={props.id || dataFieldText || props.ariaLabel}
                onChange={(e) => setter(dataFieldText, e.target.value)}
                wiz={props.wiz}
                keyName={props.keyName}
            />
        </Validation>
    )
}

TextareaWiz.propTypes = {
    wiz: PropTypes.any.isRequired,
    keyName: PropTypes.string.isRequired,
    name: PropTypes.string,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    onlyNumbers: PropTypes.bool,
    limitterFloat: PropTypes.oneOf(['end', 'start']),
    rows: PropTypes.number,
    className: PropTypes.string,
    hideLimitter: PropTypes.bool,
    readOnly: PropTypes.bool,
    hideLabel: PropTypes.bool,
    noLabel: PropTypes.bool,
    title: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.any,
    row: PropTypes.any,
    setRow: PropTypes.func,
    ariaLabel: PropTypes.string,
    idx: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default TextareaWiz
